<div class="outerwrap">
    <div class="mat-elevation-z3">
        <h2 class="mat-title">Welcome to DELTA!</h2>
        <p>
            The Dual Enrollment Link to Advisors (DELTA) System is a product of the Polk County School District and is intended to serve as a portal for the creation, processing, and management of dual enrollment course requests for all students in the Polk County School District.
        </p>
        <p>
            The system is currently processing your login. Please wait...
        </p>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/ssologin/ssologin.component.html